// src/screens/TrackerScreen.tsx
import { useEffect, useState } from 'react';
import { useTrackerStore } from '../stores/trackerStore';
import { TrackerList } from '../components/TrackerList';
import { FiDownload, FiTrash2 } from 'react-icons/fi';
import { indexedDBRepo } from '../services/trackerRepo';
import { useBankrollStore } from '../stores/bankrollStore';

export function TrackerScreen() {
  const { load, clearAll, stats } = useTrackerStore();
  const { load: loadBankroll, reset: resetBankroll, state: bank, available, totalProfit, roi, setInitial } = useBankrollStore();
  const [editingBank, setEditingBank] = useState(false);
  const [bankValue, setBankValue] = useState('');

  useEffect(() => {
    let active = true;
    void (async () => {
      const migrationKey = 'rushprops.bankroll.zero.v1';
      let initialized = false;
      try { initialized = localStorage.getItem(migrationKey) === 'done'; } catch { initialized = false; }
      if (!initialized) {
        await resetBankroll(0);
        try { localStorage.setItem(migrationKey, 'done'); } catch { /* The zero balance remains in IndexedDB. */ }
      }
      if (active) { await load(); await loadBankroll(); }
    })();
    return () => { active = false; };
  }, [load, loadBankroll, resetBankroll]);

  const handleExport = () => {
    indexedDBRepo.getAll().then((entries) => {
      const blob = new Blob([JSON.stringify(entries, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `rush-props-tracker-${new Date().toISOString().split('T')[0]}.json`;
      a.click();
      URL.revokeObjectURL(url);
    });
  };

  return (
    <div className="screen tracker-screen">
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <h1 style={{ margin: 0, fontSize: 24, fontWeight: 800 }}>Tracker</h1>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={handleExport} style={{
            padding: '8px 12px', background: 'rgba(59,130,246,0.2)', border: '1px solid rgba(59,130,246,0.4)',
            borderRadius: 8, color: '#B7FF00', fontSize: 12, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6,
          }}>
            <FiDownload size={14} /> Exportar
          </button>
          {(stats.totalPicks + stats.totalParlays) > 0 && (
            <button onClick={() => { if (confirm('Limpar todo histórico?')) clearAll(); }} style={{
              padding: '8px 12px', background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.3)',
              borderRadius: 8, color: '#EF4444', fontSize: 12, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6,
            }}>
              <FiTrash2 size={14} /> Limpar
            </button>
          )}
        </div>
      </div>

      <section className="tracker-bank-card">
        <header><div><small>BANCA DISPONÍVEL</small><strong>R$ {available.toFixed(2)}</strong></div><button onClick={() => {setBankValue(bank.initial ? String(bank.initial) : '');setEditingBank(!editingBank);}}>{editingBank ? 'Fechar' : 'Definir banca'}</button></header>
        <div className="tracker-bank-stats"><span>PnL resolvido <b className={totalProfit >= 0 ? 'positive' : 'negative'}>R$ {totalProfit.toFixed(2)}</b></span><span>ROI <b className={roi >= 0 ? 'positive' : 'negative'}>{roi.toFixed(1)}%</b></span></div>
        {editingBank && <form onSubmit={async e => {e.preventDefault(); await setInitial(Number(bankValue.replace(',','.')) || 0); setEditingBank(false);}}><label>Banca inicial (R$)<input inputMode="decimal" value={bankValue} onChange={e => setBankValue(e.target.value)} placeholder="100,00"/></label><button type="submit">SALVAR BANCA</button></form>}
      </section>

      <TrackerList />
    </div>
  );
}
